$(document).ready(function() {
  ("use strict");

  // ----------
  // feature.js
  // ----------

  if (feature.svg) {
    $("html").addClass("svg");
  }

  // -----------
  // matchHeight
  // -----------

  $(".box").matchHeight();
  $(".accessos > div").matchHeight();

  // -----
  // popup
  // -----
//  $(".popup-modal").magnificPopup({
//    type: "inline",
//    closeBtnInside: true,
//    tClose: "Tancar (Esc)",
//    closeMarkup:
//      "<button type='button' title='%title%' class='mfp-close' aria-label='Tancar'><span aria-hidden='true'></span></button>"
//  });

  // --------------------------------------------------------------------------------------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // --------------------------------------------------------------------------------------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function(event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function() {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // -----------------
  // Canvi svg per png
  // -----------------

  if (!feature.svg) {
    var imgs = document.getElementsByTagName("img");
    var endsWithDotSvg = /.*\.svg$/;
    var i = 0;
    var l = imgs.length;
    for (; i !== l; ++i) {
      if (imgs[i].src.match(endsWithDotSvg)) {
        imgs[i].src = imgs[i].src.slice(0, -3) + "png";
      }
    }
  }

  // ----------
  // File input (https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/)
  // ----------

  $(".inputfile").each(function() {
    var $input = $(this),
      $label = $input.next("label"),
      labelVal = $label.html();

    $label
      .wrapInner("<span></span>")
      .append('<i class="material-icons" aria-hidden="true">&#xe226;</i>');

    $input.on("change", function(e) {
      var fileName = "";

      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else if (e.target.value) fileName = e.target.value.split("\\").pop();

      if (fileName) $label.find("span").html(fileName);
      else $label.html(labelVal);
    });

    // Firefox bug fix
    $input
      .on("focus", function() {
        $input.addClass("has-focus");
      })
      .on("blur", function() {
        $input.removeClass("has-focus");
      });
  });

  // ------------
  // Radiobuttons (crear elements per al wtf-forms)
  // ------------

  $("label.radio, label.checkbox").append('<span class="control-indicator"></span>');
  var $help = $(".control.radio").next(".help-block");
  $.each($help, function() {
    var $label = $(this).prev(".control.radio");
    $(this).appendTo($label);
  });

  // -------
  // legends (perquè passi el validador)
  // -------

  $(".main-form legend")
    .wrapInner("<div class='container'></div>")
    .css("display", "block");

  // ---------------
  // Canvi de perfil
  // ---------------

  $(".canvi-perfil").on("click", function() {
    // afegir classe al body
    // $("body").toggleClass("js-menu-open");
    $(".perfils").css("display", "block");
    // canviar atributs del botó i del menú
    // if ($(this).attr("aria-expanded") == "true") {
    //   $(this).attr("aria-expanded", "false");
    //   $(".menu-wrapper")
    //     .attr("hidden", "")
    //     .addClass("js-hidden");
    // } else {
    //   $(this).attr("aria-expanded", "true");
    //   $(".menu-wrapper")
    //     .removeAttr("hidden")
    //     .removeClass("js-hidden");
    // }
  });
  $(".perfils-toggle").on("click", function() {
    $(".perfils").css("display", "none");
  });
});
